import { IGetHabilidadesDropDownUseCase } from "../../../presentation/useCases/read/get_habilidades_dropdown_use_case";
import { HabilidadeDropDown } from "../../models/habilidade_dropdown";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetHabilidadesDropDownUseCase
 */

export class GetHabilidadesDropDownUseCase implements IGetHabilidadesDropDownUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async getHabilidadesDropDown(): Promise<HabilidadeDropDown[]> {
    const response = await this.repository.getHabilidadesDropDown();
    return response;
  }
}